import Splide from "@splidejs/splide";

export default function initializeHeroSlider() {
  const items = document.querySelectorAll(".hero-slider");
  if (!items.length) return;

  function init() {
    items.forEach((item) => {
      const slider = createSlider(item);
      const hasCustomPagination = checkForCustomPagination();
      if (!hasCustomPagination) return;
      handleCustomPagination(slider);
      slider.mount();
    });
  }

  function createSlider(item) {
    const el = item.querySelector(".splide");
    const interval = item.dataset.speed * 1000 || 5000;
    const useAutoplay = item.dataset.speed > 0;
    const slider = new Splide(el, {
      type: "fade",
      rewind: true,
      autoplay: useAutoplay,
      interval: interval,
      pauseOnHover: false,
      arrows: true,
      pagination: false,
    });
    return slider;
  }

  function checkForCustomPagination() {
    return document.querySelector(".hero-slider__pagination");
  }

  function handleCustomPagination(slider) {
    const pagination = document.querySelector(".hero-slider__pagination");
    slider.on("ready", () => {
      addPaginationMarkup(pagination);
      setPaginationValues(slider, pagination);
    });
    slider.on("moved", () => {
      setPaginationValues(slider, pagination);
    });
  }

  function addPaginationMarkup(container) {
    container.innerHTML = `
      <div class="pagination__num pagination__num--current"></div>
      <div class="pagination__seperator">/</div>
      <div class="pagination__num pagination__num--total"></div>
    `;
  }

  function setPaginationValues(slider, container) {
    const current = container.querySelector(".pagination__num--current");
    const total = container.querySelector(".pagination__num--total");
    const currentSlide = slider.index + 1;
    const totalSlides = slider.length;
    current.textContent = currentSlide;
    total.textContent = totalSlides;
    updatePaginationClasses(slider, container);
  }

  function updatePaginationClasses(slider, container) {
    const current = container.querySelector(".pagination__num--current");
    const total = container.querySelector(".pagination__num--total");
    const currentSlide = slider.index + 1;
    const totalSlides = slider.length;
    if (currentSlide === 1) {
      current.classList.add("pagination__num--first");
      total.classList.remove("pagination__num--last");
    } else if (currentSlide === totalSlides) {
      current.classList.remove("pagination__num--first");
      total.classList.add("pagination__num--last");
    } else {
      current.classList.remove("pagination__num--first");
      total.classList.remove("pagination__num--last");
    }
  }

  init();
}
